import { render, staticRenderFns } from "./Cave.vue?vue&type=template&id=12afc580&scoped=true"
import script from "./Cave.vue?vue&type=script&lang=js"
export * from "./Cave.vue?vue&type=script&lang=js"
import style0 from "./Cave.vue?vue&type=style&index=0&id=12afc580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12afc580",
  null
  
)

export default component.exports